<template>
<div class="mr15">
  <sui-page>
    <sui-page-contents>      
      <sui-grid :columns="gridColumns0" :dataset="'dataset0'" :initialPagesize="5" :autoheight="false" :pageable="true">        
      </sui-grid>
      <sui-grid :columns="gridColumns0" :dataset="'dataset1'" :initialPagesize="10" :autoheight="false" :pageable="true" :autoShrink="true" >        
      </sui-grid>
      <sui-grid :columns="gridColumns0" :dataset="'dataset1'" :initialPagesize="30" :pagesizeoptions="[15, 30]" :autoheight="false" :pageable="true">
      </sui-grid>
      <sui-grid :columns="gridColumns0" :dataset="'dataset1'" :initialPagesize="3" :pagesizeoptions="[3, 15, 30]" :autoShrink="true" :autoheight="false" :pageable="true">
      </sui-grid>
      <div v-show="false">
        <sui-jqx-grid :columns="gridColumns0" :dataset="'dataset0'" :pageable="true" :autoheight="false" />
      </div>
    </sui-page-contents>
  </sui-page>
</div>
</template>
<script>

export default {
  name: 'DatasetWithComponent',
  data() {
    return {
      gridColumns0: [{
        text: '모듈',
        datafield: 'moduleCode',
        width: 90
      }, {
        text: '서브모듈',
        datafield: 'subModuleCode'
      }, {
        text: '페이지유형',
        datafield: 'pageTypeCode',
        cellsalign: 'center'
      }, {
        text: '페이지 ID',
        datafield: 'pageId'
      }, {
        text: '페이지 명',
        datafield: 'pageName',
        createwidget: (row, column, value, htmlElement) => {
          const editorInstance = utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement, {
            trim: true,
          }, this.dataset0);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: '수정자',
        datafield: 'finalModificationUserId'
      }, {
        text: '수정일시',
        datafield: 'finalModificationDTM',
        $component: this,        
      }],
      localdata1: [],
      localdata0: [{
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00001",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00001",
          "pageId": "PGE_CMS_00000",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "Y",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": moment("2019-05-10"),
          "pageUsePriodFinishDatetime": "9999-12-31",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
          'rangeDate': { start: "2019-01-10", end: '2019-02-15' },
        },
        {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00003",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00003",
          "pageId": "PGE_CMS_00001",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "N",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "20190510125916",
          "pageUsePriodFinishDatetime": "99991231235959",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
          'rangeDate': { start: "2019-02-10", end: '2019-02-15' },
        },
        {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00005",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00005",
          "pageId": "PGE_CMS_00002",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "Y",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "20190510125916",
          "pageUsePriodFinishDatetime": "99991231235959",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
          'rangeDate': { start: "2019-03-10", end: '2019-03-15' },
        },
        {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00002",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00002",
          "pageId": "PGE_CMS_00003",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "N",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "20190510125916",
          "pageUsePriodFinishDatetime": "99991231235959",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
          'rangeDate': '2019-07-10~2019-07-15',
        },
        {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00004",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00004",
          "pageId": "PGE_CMS_00004",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "Y",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "20190510125916",
          "pageUsePriodFinishDatetime": "99991231235959",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
        },
        {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00001",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00001",
          "pageId": "PGE_CMS_00005",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "Y",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "20190510125916",
          "pageUsePriodFinishDatetime": "99991231235959",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
        },
        {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00001",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00001",
          "pageId": "PGE_CMS_00006",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "Y",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "20190510125916",
          "pageUsePriodFinishDatetime": "99991231235959",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
        },
        {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00001",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00001",
          "pageId": "PGE_CMS_00007",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "Y",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "20190510125916",
          "pageUsePriodFinishDatetime": "99991231235959",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
        },
        {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00001",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00001",
          "pageId": "PGE_CMS_00008",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "Y",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "20190510125916",
          "pageUsePriodFinishDatetime": "99991231235959",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
        },
        {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00001",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00001",
          "pageId": "PGE_CMS_00009",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "Y",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "20190510125916",
          "pageUsePriodFinishDatetime": "99991231235959",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
        },
        {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00001",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00001",
          "pageId": "PGE_CMS_00010",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "Y",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "20190510125916",
          "pageUsePriodFinishDatetime": "99991231235959",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
        }, {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00001",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00001",
          "pageId": "PGE_CMS_00011",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "Y",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "20190510125916",
          "pageUsePriodFinishDatetime": "99991231235959",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
        }, {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00001",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00001",
          "pageId": "PGE_CMS_00012",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "Y",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "20190510125916",
          "pageUsePriodFinishDatetime": "99991231235959",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
        }, {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00001",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00001",
          "pageId": "PGE_CMS_00013",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "Y",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "20190510125916",
          "pageUsePriodFinishDatetime": "99991231235959",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
        },
      ],
    };
  },
  mounted() {
    this.localdata1 = this.dataset1.setRawData([...this.localdata0]);
  },
  datasets: [{
    id: 'dataset0',
    type: 'local',
    data: 'localdata0',
    datafields: [{
        "name": "deleteYn",
        "type": "string",
        "map": "deleteYn"
      },
      {
        "name": "firstRegistrationDTM",
        "type": "string",
        "map": "firstRegistrationDTM"
      },
      {
        "name": "firstRegistrationUserId",
        "type": "string",
        "map": "firstRegistrationUserId"
      },
      {
        "name": "firstRegistrationProgramId",
        "type": "string",
        "map": "firstRegistrationProgramId"
      },
      {
        "name": "finalModificationDTM",
        "type": "string",
        "map": "finalModificationDTM"
      },
      {
        "name": "finalModificationUserId",
        "type": "string",
        "map": "finalModificationUserId"
      },
      {
        "name": "finalModificationProgramId",
        "type": "string",
        "map": "finalModificationProgramId"
      },
      {
        "name": "pageId",
        "type": "string",
        "map": "pageId"
      },
      {
        "name": "moduleCode",
        "type": "string",
        "map": "moduleCode"
      },
      {
        "name": "subModuleCode",
        "type": "string",
        "map": "subModuleCode"
      },
      {
        "name": "pageName",
        "type": "string",
        "map": "pageName"
      },
      {
        "name": "pageTitleMessageResourceId",
        "type": "string",
        "map": "pageTitleMessageResourceId"
      },
      {
        "name": "pageTypeCode",
        "type": "string",
        "map": "pageTypeCode"
      },
      {
        "name": "pageDestinationValue",
        "type": "string",
        "map": "pageDestinationValue"
      },
      {
        "name": "pageStatusCode",
        "type": "string",
        "map": "pageStatusCode"
      },
      {
        "name": "pageBlockContent",
        "type": "string",
        "map": "pageBlockContent"
      },
      {
        "name": "pageUseYn",
        "type": "string",
        "map": "pageUseYn"
      },
      {
        "name": "pageUsePriodYn",
        "type": "string",
        "map": "pageUsePriodYn"
      },
      {
        "name": "pageUsePriodStartDatetime",
        "type": "string",
        "map": "pageUsePriodStartDatetime"
      },
      {
        "name": "pageUsePriodFinishDatetime",
        "type": "string",
        "map": "pageUsePriodFinishDatetime"
      },
      {
        "name": "pagePopupYn",
        "type": "string",
        "map": "pagePopupYn"
      },
      {
        "name": "pagePopupOptionValue",
        "type": "string",
        "map": "pagePopupOptionValue"
      },
      {
        "name": "searchPageCond",
        "type": "string",
        "map": "searchPageCond"
      },
      {
        "name": "searchPageText",
        "type": "string",
        "map": "searchPageText"
      },
      {
        "name": "lang",
        "type": "string",
        "map": "lang"
      },
      {
        "name": "rangeDate",
        "type": "string",
        "map": "rangeDate"
      },
    ]
  },
  {
    id: 'dataset1',
    type: 'local',
    data: 'localdata1',
    datafields: [{
        "name": "deleteYn",
        "type": "string",
        "map": "deleteYn"
      },
      {
        "name": "firstRegistrationDTM",
        "type": "string",
        "map": "firstRegistrationDTM"
      },
      {
        "name": "firstRegistrationUserId",
        "type": "string",
        "map": "firstRegistrationUserId"
      },
      {
        "name": "firstRegistrationProgramId",
        "type": "string",
        "map": "firstRegistrationProgramId"
      },
      {
        "name": "finalModificationDTM",
        "type": "string",
        "map": "finalModificationDTM"
      },
      {
        "name": "finalModificationUserId",
        "type": "string",
        "map": "finalModificationUserId"
      },
      {
        "name": "finalModificationProgramId",
        "type": "string",
        "map": "finalModificationProgramId"
      },
      {
        "name": "pageId",
        "type": "string",
        "map": "pageId"
      },
      {
        "name": "moduleCode",
        "type": "string",
        "map": "moduleCode"
      },
      {
        "name": "subModuleCode",
        "type": "string",
        "map": "subModuleCode"
      },
      {
        "name": "pageName",
        "type": "string",
        "map": "pageName"
      },
      {
        "name": "pageTitleMessageResourceId",
        "type": "string",
        "map": "pageTitleMessageResourceId"
      },
      {
        "name": "pageTypeCode",
        "type": "string",
        "map": "pageTypeCode"
      },
      {
        "name": "pageDestinationValue",
        "type": "string",
        "map": "pageDestinationValue"
      },
      {
        "name": "pageStatusCode",
        "type": "string",
        "map": "pageStatusCode"
      },
      {
        "name": "pageBlockContent",
        "type": "string",
        "map": "pageBlockContent"
      },
      {
        "name": "pageUseYn",
        "type": "string",
        "map": "pageUseYn"
      },
      {
        "name": "pageUsePriodYn",
        "type": "string",
        "map": "pageUsePriodYn"
      },
      {
        "name": "pageUsePriodStartDatetime",
        "type": "string",
        "map": "pageUsePriodStartDatetime"
      },
      {
        "name": "pageUsePriodFinishDatetime",
        "type": "string",
        "map": "pageUsePriodFinishDatetime"
      },
      {
        "name": "pagePopupYn",
        "type": "string",
        "map": "pagePopupYn"
      },
      {
        "name": "pagePopupOptionValue",
        "type": "string",
        "map": "pagePopupOptionValue"
      },
      {
        "name": "searchPageCond",
        "type": "string",
        "map": "searchPageCond"
      },
      {
        "name": "searchPageText",
        "type": "string",
        "map": "searchPageText"
      },
      {
        "name": "lang",
        "type": "string",
        "map": "lang"
      },
      {
        "name": "rangeDate",
        "type": "string",
        "map": "rangeDate"
      },
    ]
  }
],
  methods: {
    // $getDataset(datasetStr) {
    //   const ds = utils.findDataset(datasetStr);
    //   return ds;
    // }
  }
};
</script>
